import { tchMarked } from "@common/Common";
import { ScoringAlternativeReadModel, ScoringAttributeReadModel, ScoringListReadModel, ScoringStatusReadModel, SurveyAlternativesManagerReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";

export class SurveyAlternativesManagerDialogViewModel
{
    opened: boolean = false;

    initialized: boolean = false;
    alternativesLabel: string = "Alternatives";
    searchPhrase: string | null = null;
    filterLabel: string = null;
    activeTab: string = "Alternatives";
    previewMode: boolean = false;

    surveyId: number = null;
    surveyName: string = null;
    alternativeDescriptionPreview: string | null = null;
    filteredIds: string[] | null = null;
    filtering: boolean = false;

    descriptionTemplate: string | null = null;

    attributes: ScoringAttributeReadModel[] = [];
    statuses: ScoringStatusReadModel[] = [];
    lists: ScoringListReadModel[] = [];
    alternatives: ScoringAlternativeReadModel[] = [];

    get filteredAlternatives() { return this.filteredIds != null ? this.alternatives.filter(a => this.filteredIds.includes(a.Id)) : this.alternatives; }
    get alternativesView() { return this.searchPhrase ? this.filteredAlternatives.filter(o => o.Name.toLowerCase().includes(this.searchPhrase.toLowerCase())) : this.filteredAlternatives;  }
    get includedAlternatives() { return this.alternatives.filter(a => a.IsIncluded === true) ?? []; }


    show(surveyId: number, surveyName: string, alternativesLabel: string)
    {
        this.initialized = false;

        this.alternativesLabel = alternativesLabel;
        this.searchPhrase = null;
        this.filterLabel = null;
        this.activeTab = "Alternatives";
        this.previewMode = false;
        this.descriptionTemplate = null;

        this.surveyId = surveyId;
        this.surveyName = surveyName;
        this.alternativeDescriptionPreview = null;
        this.filteredIds = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.initialized = false;
    }

    setData(rm: SurveyAlternativesManagerReadModel)
    {
        this.descriptionTemplate = rm.AlternativeDescriptionTemplate;

        this.attributes = rm.Attributes;
        this.statuses = rm.Statuses;
        this.lists = rm.Lists;
        this.alternatives = rm.Alternatives;

        this.initialized = true;
    }

    setPreview(preview: string)
    {
        this.alternativeDescriptionPreview = tchMarked(preview);
    }

    filteredByIds(ids: string[])
    {
        this.filteredIds = ids;
        this.filtering = false;
    }

    filterIncluded()
    {
        this.filterLabel = "Included in the survey";
        this.filteredIds = this.alternatives.filter(a => a.IsIncluded === true).map(a => a.Id);

        this.filtering = false;
    }

    filterExcluded()
    {
        this.filterLabel = "Not included in the survey";
        this.filteredIds = this.alternatives.filter(a => a.IsIncluded === false).map(a => a.Id);

        this.filtering = false;
    }

    filterByStatus(statusId: number, statusName: string)
    {
        this.filterLabel = `Status [${statusName}]`;

        this.filteredIds = this.alternatives.filter(a => a.StatusId === statusId).map(a => a.Id);

        this.filtering = false;
    }

    filterByList(listId: string, listName: string)
    {
        this.filterLabel = `List [${listName}]`;

        this.filtering = true;
        this.filteredIds = [];
    }

    clearFilter()
    {
        this.filterLabel = null;
        this.filteredIds = null;
        this.filtering = false;
    }
}

export class SurveyAlternativesManagerDialogSaveEventPayload
{
    id: number;
    descriptionTemplate: string;
    alternativeIds: number[];

    constructor(id: number, descriptionTemplate: string, alternativeIds: number[])
    {
        this.id = id;
        this.descriptionTemplate = descriptionTemplate;
        this.alternativeIds = alternativeIds;
    }
}